import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import {
  CreateProcessStep,
  createProcessStep,
} from "#modules/processSteps/infra/createProcessStep.api";
import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";
import { quoteRequestProcessStepsQuery } from "#modules/quoteRequests/infra/quoteRequestProcessSteps.query";

export const useCreateProcessStep = (
  quoteRequestId?: string,
  options?: { onSuccess?: (processStep: CreateProcessStep) => void },
) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: createProcessStep,
    onMutate: () => {},
    onSuccess: (processStep: CreateProcessStep) => {
      void queryClient.invalidateQueries(
        quoteRequestLineQuery({ id: processStep.quoteRequestLineId ?? "" }),
      );
      if (quoteRequestId) {
        void queryClient.invalidateQueries(quoteRequestQuery(quoteRequestId));
        void queryClient.invalidateQueries(quoteRequestProcessStepsQuery(quoteRequestId));
      }
      options?.onSuccess?.(processStep);
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { createProcessStep: mutate, ...rest };
};
